export interface Bonus {
  id: string
  title: string
  value: string
  desc: string
  benefit: string
  /** Accent classes keep all five bonuses inside the same warm, natural family */
  tagClass: string
  iconClass: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: '150 Complete Ready-to-Teach Sessions',
    value: '20',
    desc: 'A complete bank of attention, body awareness, grounding, compassion, open awareness, emotional regulation, and independent practice sessions — with minute-by-minute timing, teacher cueing, corrections, adaptations, and variations.',
    benefit: 'No prep needed. Open, choose, and teach.',
    tagClass: 'bg-brand text-white',
    iconClass: 'bg-brand-soft text-brand-dark border-brand/25',
  },
  {
    id: '02',
    title: 'Teacher Cueing, Language & Troubleshooting Mastery',
    value: '18',
    desc: 'Professional cueing ready to speak and practical corrections for attention, body awareness, grounding, breathing, thoughts, emotions, compassion, and silence. Includes 75 troubleshooting scenarios for when the group gets restless or a practice is not landing.',
    benefit: 'The words are already there. Just say them.',
    tagClass: 'bg-olive text-white',
    iconClass: 'bg-olive-soft text-olive border-olive/25',
  },
  {
    id: '03',
    title: '75 Class Rescue Sessions for Emergencies',
    value: '16',
    desc: 'Short sessions, simplified versions, quick alternatives, and emergency practices for when your original plan fails, when the group arrives different, or when you need something immediately.',
    benefit: 'Have the right session ready before class begins.',
    tagClass: 'bg-accent text-white',
    iconClass: 'bg-accent-soft text-accent-dark border-accent/25',
  },
  {
    id: '04',
    title: 'Workshops, Retreats & Special Events Toolkit',
    value: '16',
    desc: 'Planning and sequencing tools for workshops, mini-retreats, and special experiences: agendas, session flows, transitions, breaks, event openings and closings, and participant communication.',
    benefit: 'Open, organize, facilitate — without last-minute panic.',
    tagClass: 'bg-toast text-ink',
    iconClass: 'bg-cream text-graphite border-toast',
  },
  {
    id: '05',
    title: 'Business, Private Sessions & Program Growth Toolkit',
    value: '16',
    desc: 'Private session structures, program offers and pricing guidance, scheduling and organization systems, participant pathways, professional packages, recurring programs, and growth opportunities.',
    benefit: 'Build a thriving teaching practice while keeping students engaged.',
    tagClass: 'bg-gold text-ink',
    iconClass: 'bg-gold-soft text-accent-dark border-gold/60',
  },
]

export const bonusesTotalValue = '$86.00'
